import { ResponsivePie } from "@nivo/pie";
const colors = { "Active deals": "#37CFD6", "Past deals": "#696AE7" };
const getColor = (part) => {
  return colors[part.label];
};

const PieChart = ({ data /* see data tab */ }) => (
  <ResponsivePie
    data={data}
    // margin={{ top: 40, right: 80, bottom: 80, left: 80 }}

    innerRadius={0.88}
    padAngle={2}
    cornerRadius={7}
    activeOuterRadiusOffset={0}
    // colors={{ scheme: "nivo" }}
    colors={getColor}
    borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
    enableArcLinkLabels={false}
    arcLinkLabelsSkipAngle={10}
    arcLinkLabelsTextColor="#333333"
    arcLinkLabelsThickness={2}
    arcLinkLabelsColor={{ from: "color" }}
    enableArcLabels={false}
    arcLabelsSkipAngle={10}
    arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
    defs={[
      {
        id: "dots",
        type: "patternDots",
        background: "inherit",
        color: "rgba(255, 255, 255, 0.3)",
        size: 4,
        padding: 1,
        stagger: true,
      },
      {
        id: "lines",
        type: "patternLines",
        background: "inherit",
        color: "rgba(255, 255, 255, 0.3)",
        rotation: -45,
        lineWidth: 6,
        spacing: 10,
      },
    ]}
  />
);

export default PieChart;
